export enum ActionType {
    READ_DATA = '[Message Context] READ DATA',
    SELECT_PAGE = '[Message Context] SELECT PAGE',
    RESET_PAGE = '[Message Context] RESET PAGE',
    SET_TOTAL_NUMBER_OF_MESSAGES = '[Message Context] SET TOTAL NUMBER OF MESSAGES',
    CLOSE_DETAILS = '[Message Context] CLOSE DETAIL',
}
